module.exports = __webpack_public_path__ + "img/bag.8db9dbec.svg";